import 'css-chunksrc/feature/pos/TerminalDetails.module.scss';export default {
  "root": "TerminalDetails_root",
  "btnLabel": "TerminalDetails_btnLabel",
  "clock": "TerminalDetails_clock",
  "input_spacer": "TerminalDetails_input_spacer",
  "input_validation_spacer": "TerminalDetails_input_validation_spacer"
};